var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sold-out scroll-touch"},[_c('fixed-header',{attrs:{"title":"商品已下架"}}),_c('div',{staticClass:"sold-out__main"},[_c('div',{staticClass:"sold-out__top"},[_c('img',{attrs:{"src":_vm.bgImg}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }